import baseState from '@js/configs/BaseApplyModule/state'
import baseMutations from '@js/configs/BaseApplyModule/mutations'
import baseActions from '@js/configs/BaseApplyModule/actions'
import baseGetters from '@js/configs/BaseApplyModule/getters'
import merge from 'lodash/merge'

const applyModule = {
    // State
    state: merge(baseState, {
        data: {
            emailAddress: {
                value: null,
            },
            creditRating: {
                value: null,
            },
            state: {
                value: null,
            },
        },
    }),

    // Mutations
    mutations: baseMutations,

    // Actions
    actions: baseActions,

    // Getters
    getters: baseGetters,
}

export default applyModule
